import { AddonsAddonListResponse } from '@api/types.gen';

import { Card } from '@@/primitives/Card';

import { AddonCard } from './AddonCard';

interface Props {
  catalog: AddonsAddonListResponse;
  disabled?: boolean;
}

export function AddonsCards({ catalog: { addons }, disabled = false }: Props) {
  if (!addons?.length) {
    return (
      <div className="m-4">
        <Card.Container aria-label="No addons in catalog" className="h-full">
          <Card.Body>
            <p className="mb-0 w-full text-center">
              No add-ons available to install
            </p>
          </Card.Body>
        </Card.Container>
      </div>
    );
  }

  return (
    <div className="m-4 flex flex-col gap-4">
      {addons.map((addon) => (
        <AddonCard key={addon.path} addon={addon} disabled={disabled} />
      ))}
    </div>
  );
}
